// Categorical market palette, CVD-validated against app surfaces
// (#fcfcfc light, #151d2c dark). Fixed assignment by resource order;
// never cycle or generate hues. Accent orange is reserved for ensemble.
export const MARKET_COLORS_LIGHT = ['#0891b2', '#8b5cf6', '#db2777', '#b45309'];
export const MARKET_COLORS_DARK = ['#22a3b8', '#8b5cf6', '#ec4899', '#d97706'];
export const ENSEMBLE_COLOR = '#FF7926';

export const marketColor = (index, dark) => {
  const palette = dark ? MARKET_COLORS_DARK : MARKET_COLORS_LIGHT;
  return palette[index % palette.length];
};
